import { contentLoaded, mouseDown, virtualContentLoaded, cellNavigate, getUpdateUsingRaf, focusBorder, positionAutoFillElement, hideAutoFillOptions, performAutoFill, selectAutoFillRange, rangeSelectionByKeydown, removeCommentContainer, initiateComment, deInitProperties } from '../common/index';
import { showAggregate, refreshOverlayElem, getRowIdxFromClientY, getColIdxFromClientX, hideAutoFillElement, showNote } from '../common/index';
import { updateSelectedRange, getColumnWidth, mergedRange, activeCellMergedRange, getSelectedRange, checkColumnValidation } from '../../workbook/index';
import { getRowHeight, isSingleCell, activeCellChanged, checkIsFormula, getSheetIndex } from '../../workbook/index';
import { EventHandler, addClass, removeClass, isNullOrUndefined, Browser, closest, remove, detach, getComponent } from '@syncfusion/ej2-base';
import { getMoveEvent, getEndEvent, isTouchStart, isMouseUp, isDiscontinuousRange } from '../common/index';
import { isTouchEnd, isTouchMove, getClientX, getClientY, mouseUpAfterSelection, selectRange, rowHeightChanged, completeAction } from '../common/index';
import { colWidthChanged, protectSelection, editOperation, initiateFormulaReference, initiateCur, clearCellRef, getScrollBarWidth } from '../common/index';
import { getRangeIndexes, getCellAddress, getRangeAddress, getCellIndexes, getSwapRange } from '../../workbook/common/address';
import { addressHandle, isMouseDown, isMouseMove, selectionStatus, setPosition, removeRangeEle, removeNoteContainer, setActionData } from '../common/index';
import { isCellReference, getSheetNameFromAddress, isLocked, getColumn, getCell, updateCell, getSheetName } from '../../workbook/index';
import { selectionComplete, parseFormulaArgument, getChartRowIdxFromClientY, getChartColIdxFromClientX, addDPRValue, isRowSelected, isColumnSelected } from '../../workbook/common/index';
import { getIndexesFromAddress, skipHiddenIdx, isHiddenRow, isHiddenCol } from '../../workbook/index';
/**
 * Represents selection support for Spreadsheet.
 */
export class Selection {
    /**
     * Constructor for the Spreadsheet selection module.
     *
     * @param {Spreadsheet} parent - Constructor for the Spreadsheet selection module.
     * @private
     */
    constructor(parent) {
        this.invalidOperators = ['%'];
        this.formulaRange = [];
        /** @hidden */
        this.isNoteActiveElement = false;
        this.isNoteTouch = false;
        this.isCommentTouch = false;
        this.parent = parent;
        this.addEventListener();
        this.mouseMoveEvt = this.mouseMoveHandler.bind(this);
    }
    addEventListener() {
        this.parent.on(contentLoaded, this.init, this);
        this.parent.on(deInitProperties, this.deInitProps, this);
        this.parent.on(mouseDown, this.mouseDownHandler, this);
        this.parent.on(virtualContentLoaded, this.virtualContentLoadedHandler, this);
        this.parent.on(cellNavigate, this.cellNavigateHandler, this);
        this.parent.on(selectRange, this.selectRange, this);
        this.parent.on(rowHeightChanged, this.rowHeightChanged, this);
        this.parent.on(colWidthChanged, this.colWidthChanged, this);
        this.parent.on(protectSelection, this.protectHandler, this);
        this.parent.on(initiateFormulaReference, this.initiateFormulaSelection, this);
        this.parent.on(clearCellRef, this.clearBorder, this);
        this.parent.on(getRowIdxFromClientY, this.getRowIdxFromClientY, this);
        this.parent.on(getColIdxFromClientX, this.getColIdxFromClientX, this);
        this.parent.on(getChartRowIdxFromClientY, this.getRowIdxFromClientY, this);
        this.parent.on(getChartColIdxFromClientX, this.getColIdxFromClientX, this);
        this.parent.on(focusBorder, this.chartBorderHandler, this);
        this.parent.on(selectionStatus, this.isTouchSelectionStarted, this);
        this.parent.on(rangeSelectionByKeydown, this.selectionByKeydown, this);
    }
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(contentLoaded, this.init);
            this.parent.off(deInitProperties, this.deInitProps);
            this.parent.off(mouseDown, this.mouseDownHandler);
            this.parent.off(virtualContentLoaded, this.virtualContentLoadedHandler);
            this.parent.off(cellNavigate, this.cellNavigateHandler);
            this.parent.off(selectRange, this.selectRange);
            this.parent.off(rowHeightChanged, this.rowHeightChanged);
            this.parent.off(colWidthChanged, this.colWidthChanged);
            this.parent.off(protectSelection, this.protectHandler);
            this.parent.off(initiateFormulaReference, this.initiateFormulaSelection);
            this.parent.off(clearCellRef, this.clearBorder);
            this.parent.off(getRowIdxFromClientY, this.getRowIdxFromClientY);
            this.parent.off(getColIdxFromClientX, this.getColIdxFromClientX);
            this.parent.off(getChartRowIdxFromClientY, this.getRowIdxFromClientY);
            this.parent.off(getChartColIdxFromClientX, this.getColIdxFromClientX);
            this.parent.off(focusBorder, this.chartBorderHandler);
            this.parent.off(selectionStatus, this.isTouchSelectionStarted);
            this.parent.off(rangeSelectionByKeydown, this.selectionByKeydown);
        }
    }
    deInitProps() {
        const main = this.parent.getMainContent();
        if (main) {
            const sel = main.querySelector('.e-selection');
            const active = main.querySelector('.e-active-cell');
            if (sel && sel.parentElement) {
                sel.parentElement.removeChild(sel);
            }
            if (active && active.parentElement) {
                active.parentElement.removeChild(active);
            }
        }
    }
    isTouchSelectionStarted(args) {
        args.touchSelectionStarted = this.touchSelectionStarted;
    }
    selectionByKeydown(args) {
        this.selectRangeByIdx(args.range, args.e, false, false, false, false, undefined, false);
    }
    rowHeightChanged(args) {
        if (!args.threshold) {
            return;
        }
        getUpdateUsingRaf(() => {
            if (!this.parent) {
                return;
            }
            const sheet = this.parent.getActiveSheet();
            let ele = this.getActiveCell();
            if (ele && (sheet.frozenRows || sheet.frozenColumns || sheet.selectedRange.includes(' '))) {
                this.selectRange({ address: sheet.selectedRange, isRowHeightChanged: true });
                return;
            }
            const sRange = getSwapRange(getRangeIndexes(sheet.selectedRange));
            const mergeArgs = { range: sRange, isActiveCell: false, skipChecking: true };
            let isActiveCell;
            if (ele) {
                const rowIdx = getCellIndexes(sheet.activeCell)[0];
                this.parent.notify(mergedRange, mergeArgs);
                if (mergeArgs.isActiveCell) {
                    const cell = getCell(sRange[0], sRange[1], sheet, false, true);
                    isActiveCell = cell.rowSpan > 1 && sRange[0] <= args.rowIdx && sRange[2] >= args.rowIdx;
                }
                if (rowIdx === args.rowIdx || isActiveCell) {
                    ele.style.height = `${parseFloat(ele.style.height) + args.threshold}px`;
                }
                else if (rowIdx > args.rowIdx) {
                    ele.style.top = `${parseFloat(ele.style.top) + args.threshold}px`;
                }
            }
            ele = this.getSelectionElement();
            if (ele) {
                if (isActiveCell || (sRange[0] === sRange[2] && sRange[1] === sRange[3])) {
                    return;
                }
                const rowStart = sRange[0];
                const rowEnd = sRange[2];
                if (rowStart <= args.rowIdx && rowEnd >= args.rowIdx && ele) {
                    ele.style.height = `${parseFloat(ele.style.height) + args.threshold}px`;
                }
                else if (rowStart > args.rowIdx && ele) {
                    ele.style.top = `${parseFloat(ele.style.top) + args.threshold}px`;
                }
            }
        });
    }
    colWidthChanged(args) {
        if (!args.threshold) {
            return;
        }
        getUpdateUsingRaf(() => {
            if (!this.parent) {
                return;
            }
            const sheet = this.parent.getActiveSheet();
            let ele = this.getActiveCell();
            const isRtl = this.parent.enableRtl;
            if (ele && (sheet.frozenRows || sheet.frozenColumns || sheet.selectedRange.includes(' '))) {
                this.selectRange({ address: sheet.selectedRange });
                return;
            }
            const sRange = getSwapRange(getRangeIndexes(sheet.selectedRange));
            const e = { range: sRange, isActiveCell: false, skipChecking: true };
            let isActiveCell;
            if (ele) {
                this.parent.notify(mergedRange, e);
                const colIdx = getCellIndexes(sheet.activeCell)[1];
                if (e.isActiveCell) {
                    const cell = getCell(sRange[0], sRange[1], sheet, false, true);
                    isActiveCell = cell.rowSpan > 1 || cell.colSpan > 1;
                }
                if (colIdx === args.colIdx || isActiveCell) {
                    ele.style.width = `${parseFloat(ele.style.width) + args.threshold}px`;
                }
                else if (colIdx > args.colIdx) {
                    if (isRtl) {
                        ele.style.right = `${parseFloat(ele.style.right) + args.threshold}px`;
                    }
                    else {
                        ele.style.left = `${parseFloat(ele.style.left) + args.threshold}px`;
                    }
                }
            }
            ele = this.getSelectionElement();
            if (!ele || isActiveCell || (sRange[0] === sRange[2] && sRange[1] === sRange[3])) {
                return;
            }
            const colStart = sRange[1];
            const colEnd = sRange[3];
            if (colStart <= args.colIdx && colEnd >= args.colIdx && ele) {
                ele.style.width = `${parseFloat(ele.style.width) + args.threshold}px`;
            }
            else if (colStart > args.colIdx && ele) {
                if (isRtl) {
                    ele.style.right = `${parseFloat(ele.style.right) + args.threshold}px`;
                }
                else {
                    ele.style.left = `${parseFloat(ele.style.left) + args.threshold}px`;
                }
            }
        });
    }
    selectRange(args) {
        args.address = this.parent.selectionSettings.mode === 'Single' ? getRangeAddress(getCellIndexes(args.address)) : args.address;
        this.selectMultiRange(args.address, null, null, args.skipChecking, args.isRowHeightChanged);
    }
    init() {
        this.createSelectionElement();
        const sheet = this.parent.getActiveSheet();
        const sRange = getSwapRange(getRangeIndexes(sheet.selectedRange));
        const actRange = getCellIndexes(sheet.activeCell);
        const inRange = sRange[0] <= actRange[0] && sRange[2] >= actRange[0] && sRange[1] <= actRange[1]
            && sRange[3] >= actRange[1];
        this.selectMultiRange(sheet.selectedRange, true, inRange);
    }
    selectMultiRange(address, isInit, inRange, skipChecking, isisRowHeightChanged) {
        let sheetIdx = this.parent.activeSheetIndex;
        if (address.indexOf('!') > -1) {
            sheetIdx = getSheetIndex(this.parent, getSheetNameFromAddress(address));
            address = address.substring(address.lastIndexOf('!') + 1);
        }
        if (this.parent.activeSheetIndex === sheetIdx) {
            address.split(' ').forEach((rng, idx) => {
                this.selectRangeByIdx(getRangeIndexes(rng), { type: 'mousedown', ctrlKey: idx !== 0 }, null, inRange, isInit, skipChecking, undefined, false, isisRowHeightChanged);
            });
        }
        else {
            updateSelectedRange(this.parent, address, this.parent.sheets[sheetIdx]);
        }
    }
    createSelectionElement() {
        const content = this.parent.getMainContent();
        let ele = this.parent.createElement('div', { className: 'e-selection' });
        content.appendChild(ele);
        ele = this.parent.createElement('div', { className: 'e-active-cell' });
        content.appendChild(ele);
    }
    isMergeActiveCell(sheet, activeIdx, rowIdx, colIdx) {
        const cell = getCell(rowIdx, colIdx, sheet, false, true);
        if ((!!cell.rowSpan && cell.rowSpan !== 1) || (!!cell.colSpan && cell.colSpan !== 1)) {
            const mergeArgs = { range: [rowIdx, colIdx, rowIdx, colIdx] };
            this.parent.notify(activeCellMergedRange, mergeArgs);
            const mergeRange = mergeArgs.range;
            return mergeRange[0] === activeIdx[0] && mergeRange[1] === activeIdx[1];
        }
        return false;
    }
    mouseDownHandler(e) {
        this.isNoteActiveElement = !isNullOrUndefined(document) && !isNullOrUndefined(document.activeElement) &&
            typeof document.activeElement.className === 'string' && document.activeElement.className.indexOf('e-addNoteContainer') > -1;
        if (closest(e.target, '.e-scrollbar') || e.target.classList.contains('e-main-panel') ||
            e.target.classList.contains('e-sheet')) {
            return;
        }
        const eventArgs = { action: 'getCurrentEditValue', editedValue: '' };
        const sheet = this.parent.getActiveSheet();
        this.parent.notify(editOperation, eventArgs);
        const isFormulaEdit = checkIsFormula(eventArgs.editedValue, true);
        const isNoteCellIndex = this.parent.enableNotes && !isNullOrUndefined(this.parent.spreadsheetNoteModule.activeNoteCell);
        const cellIndexes = isNoteCellIndex ? this.parent.spreadsheetNoteModule.activeNoteCell : getCellIndexes(sheet.activeCell);
        const targetElement = this.parent.getCell(cellIndexes[0], cellIndexes[1]);
        let isOtherNoteContainer;
        if (!isNullOrUndefined(targetElement) && targetElement.children !== null && targetElement.children.length > 0
            && this.isNoteActiveElement && targetElement.children[targetElement.children.length - 1].classList.contains('e-addNoteIndicator')) {
            const cell = getCell(cellIndexes[0], cellIndexes[1], sheet);
            const eventAction = !isNullOrUndefined(cell) && cell.notes ? 'editNote' : 'addNote';
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            const noteModule = this.parent.spreadsheetNoteModule;
            const noteModel = noteModule.getNoteByCellIndex(cellIndexes[0], cellIndexes[1]);
            const noteId = this.parent.spreadsheetNoteModule.getNoteId(noteModel);
            const noteContainer = document.getElementById(noteId);
            const address = getSheetName(this.parent, this.parent.activeSheetIndex) + '!' + getRangeAddress(cellIndexes);
            isOtherNoteContainer = noteContainer && e.target.classList.contains('e-addNoteContainer') &&
                e.target !== noteContainer;
            if (!isNullOrUndefined(noteContainer) && !isNullOrUndefined(noteContainer.value) &&
                (e.target.className !== 'e-addNoteContainer' || isOtherNoteContainer) &&
                ((isNullOrUndefined(cell) || isNullOrUndefined(cell.notes)) ||
                    (cell.notes.text !== noteContainer.value))) {
                this.parent.notify(setActionData, { args: { action: 'beforeCellSave', eventArgs: { address: address } } });
                const updatedNote = {
                    id: noteModel.id,
                    rowIdx: cellIndexes[0],
                    colIdx: cellIndexes[1],
                    text: noteContainer.value,
                    isVisible: noteModel.isVisible
                };
                updateCell(this.parent, sheet, { rowIdx: cellIndexes[0], colIdx: cellIndexes[1], preventEvt: true,
                    cell: { notes: updatedNote, isNoteEditable: false } });
                noteModule.syncNoteToSheetArray(sheet, cellIndexes[0], cellIndexes[1], updatedNote);
                const eventArgs = { notes: updatedNote, address: address };
                this.parent.notify(completeAction, { eventArgs: eventArgs, action: eventAction });
            }
            else if (e.target.className !== 'e-addNoteContainer' || isOtherNoteContainer) {
                updateCell(this.parent, sheet, { rowIdx: cellIndexes[0], colIdx: cellIndexes[1], preventEvt: true,
                    cell: { isNoteEditable: false } });
            }
        }
        if (!this.isNoteTouch && (e.target.className !== 'e-addNoteContainer' || isOtherNoteContainer) && document.getElementsByClassName('e-addNoteContainer') && document.getElementsByClassName('e-addNoteContainer').length > 0) {
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            const note = this.parent.spreadsheetNoteModule.getNoteByCellIndex(cellIndexes[0], cellIndexes[1]);
            if (note && !note.isVisible) {
                this.parent.notify(removeNoteContainer, { rowIndex: cellIndexes[0], columnIndex: cellIndexes[1] });
            }
        }
        if (isOtherNoteContainer || e.target.classList.contains('e-addNoteContainer')) {
            const noteContainer = e.target;
            const curNoteId = noteContainer.id.split('e-note-container-')[1];
            if (sheet.notes && curNoteId) {
                const note = sheet.notes.find((note) => note.id === curNoteId);
                if (note && note.isVisible && note.rowIdx !== undefined) {
                    this.parent.spreadsheetNoteModule.activeNoteCell = [note.rowIdx, note.colIdx];
                    updateCell(this.parent, sheet, { rowIdx: note.rowIdx, colIdx: note.colIdx, preventEvt: true, cell: { isNoteEditable: true } });
                }
            }
        }
        if (this.isNoteTouch && e.type.indexOf('mouse') > -1) {
            this.isNoteTouch = false;
        }
        const commentContainer = document.getElementsByClassName('e-comment-container');
        if (!this.isCommentTouch && !closest(e.target, '.e-comment-container') &&
            commentContainer && commentContainer.length > 0) {
            this.parent.notify(removeCommentContainer, '');
        }
        if (this.isCommentTouch && e.type.indexOf('mouse') > -1) {
            this.isCommentTouch = false;
        }
        if (!this.parent.isEdit || isFormulaEdit) {
            const overlayElem = document.getElementById(this.parent.element.id + '_overlay');
            if (typeof (e.target.className) === 'string') {
                if (e.target.className.indexOf('e-ss-overlay') > -1) {
                    return;
                }
            }
            else if (overlayElem) {
                overlayElem.classList.remove('e-ss-overlay-active');
            }
            if (closest(e.target, '.e-datavisualization-chart')) {
                return;
            }
            if (sheet.isProtected && !sheet.protectSettings.selectCells && !sheet.protectSettings.selectUnLockedCells) {
                return;
            }
            if (!(closest(e.target, '.e-findtool-dlg') || closest(e.target, '.e-dragfill-ddb'))) {
                if (this.getSheetElement().contains(e.target) && !e.target.classList.contains('e-colresize')
                    && !e.target.classList.contains('e-rowresize')) {
                    const sheet = this.parent.getActiveSheet();
                    const mode = this.parent.selectionSettings.mode;
                    const mouseClientX = getClientX(e);
                    const mouseClientY = getClientY(e);
                    let rowIdx = this.getRowIdxFromClientY({ clientY: mouseClientY, target: e.target });
                    let colIdx = this.getColIdxFromClientX({ clientX: mouseClientX, target: e.target });
                    const activeIdx = getCellIndexes(sheet.activeCell);
                    let isRowSelected;
                    let isColSelected;
                    if (sheet.showHeaders) {
                        const trgt = e.target;
                        if (sheet.frozenColumns || sheet.frozenRows) {
                            let headerEle = this.parent.getSelectAllContent().querySelector('thead');
                            if (headerEle) {
                                isColSelected = (this.parent.getColumnHeaderContent().contains(trgt) || headerEle.contains(trgt)) &&
                                    trgt.classList.contains('e-header-cell') || (trgt.classList.contains('e-selectall-table') &&
                                    rowIdx < 0 && colIdx >= this.parent.frozenColCount(sheet));
                            }
                            else {
                                isColSelected = this.parent.getColumnHeaderContent().contains(trgt) &&
                                    trgt.classList.contains('e-header-cell');
                            }
                            headerEle = this.parent.getSelectAllContent().querySelector('tbody');
                            if (headerEle) {
                                isRowSelected = (this.parent.getRowHeaderContent().contains(trgt) || headerEle.contains(trgt)) &&
                                    trgt.classList.contains('e-header-cell') || (trgt.classList.contains('e-selectall-table') &&
                                    colIdx < 0 && rowIdx >= this.parent.frozenRowCount(sheet));
                            }
                            else {
                                isRowSelected = this.parent.getRowHeaderContent().contains(trgt) &&
                                    trgt.classList.contains('e-header-cell');
                            }
                            if (rowIdx === -1) {
                                rowIdx = 0;
                            }
                            if (colIdx === -1) {
                                colIdx = 0;
                            }
                        }
                        else {
                            isRowSelected = this.parent.getRowHeaderContent().contains(e.target);
                            isColSelected = this.parent.getColumnHeaderContent().contains(e.target);
                        }
                    }
                    if ((sheet.frozenRows || sheet.frozenColumns) && !isColSelected && !isRowSelected) {
                        const trgt = e.target;
                        const idx = ['e-rowhdr-table', 'e-selectall-table', 'e-colhdr-table'].findIndex((cls) => trgt.classList.contains(cls));
                        if (idx > -1) {
                            const selector = ['.e-row-header', '.e-selectall-container', '.e-column-header'][idx];
                            const closestEle = closest(trgt, selector);
                            if (closestEle && closestEle.style.zIndex) {
                                const cell = getCell(rowIdx, colIdx, sheet);
                                if ((cell && cell.validation && cell.validation.type === 'List') ||
                                    (checkColumnValidation(sheet.columns[colIdx], rowIdx, colIdx) &&
                                        sheet.columns[colIdx].validation.type === 'List')) {
                                    const td = this.parent.getCell(rowIdx, colIdx);
                                    if (td) {
                                        const listEle = td.querySelector('.e-validation-list');
                                        if (listEle) {
                                            const listEleRect = listEle.getBoundingClientRect();
                                            const dropdownClicked = mouseClientX >= listEleRect.left &&
                                                mouseClientX <= listEleRect.right && mouseClientY >= listEleRect.top &&
                                                mouseClientY <= listEleRect.bottom;
                                            if (dropdownClicked) {
                                                const ddlEle = listEle.querySelector('.e-dropdownlist');
                                                if (ddlEle) {
                                                    const ddlInst = getComponent(ddlEle, 'dropdownlist');
                                                    if (ddlInst) {
                                                        ddlInst.showPopup();
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (e.which === 3 && this.isSelected(rowIdx, colIdx)) {
                        return;
                    }
                    if (e.target.classList.contains('e-autofill')) {
                        this.isautoFillClicked = true;
                        const autoFillDdb = e.target.parentElement.querySelector('.e-dragfill-ddb');
                        if (!autoFillDdb || autoFillDdb.classList.contains('e-hide')) {
                            this.dAutoFillCell = sheet.selectedRange;
                        }
                    }
                    const topLeftIdx = getRangeIndexes(sheet.topLeftCell);
                    let range;
                    if (isRowSelected) {
                        this.isRowSelected = true;
                        if (!e.shiftKey || mode === 'Single') {
                            this.startCell = [rowIdx, 0];
                        }
                        else if (!this.startCell) {
                            this.startCell = [topLeftIdx[0], 0];
                        }
                        range = [this.startCell[0], sheet.frozenColumns ? topLeftIdx[1] : 0, rowIdx, sheet.colCount - 1];
                    }
                    else if (isColSelected) {
                        this.isColSelected = true;
                        if (!e.shiftKey || mode === 'Single') {
                            this.startCell = [0, colIdx];
                        }
                        else if (!this.startCell) {
                            this.startCell = [0, topLeftIdx[1]];
                        }
                        range = [sheet.frozenRows ? topLeftIdx[0] : 0, this.startCell[1], sheet.rowCount - 1, colIdx];
                    }
                    else if (closest(e.target, '.e-select-all-cell')) {
                        this.startCell = [sheet.frozenRows ? topLeftIdx[0] : 0, sheet.frozenColumns ? topLeftIdx[1] : 0];
                        range = [].concat(this.startCell, [sheet.rowCount - 1, sheet.colCount - 1]);
                    }
                    else if (!e.target.classList.contains('e-sheet-content')) {
                        if (!e.shiftKey || mode === 'Single') {
                            this.startCell = [rowIdx, colIdx];
                        }
                        if (!this.isautoFillClicked && !closest(e.target, '.e-filloption')) {
                            range = [].concat(this.startCell ? this.startCell : getCellIndexes(sheet.activeCell), [rowIdx, colIdx]);
                        }
                    }
                    if (isTouchStart(e) && !(isRowSelected || isColSelected) && range) {
                        const colRowSelectArgs = this.isRowColSelected(range);
                        this.isRowSelected = colRowSelectArgs.isRowSelected;
                        this.isColSelected = colRowSelectArgs.isColSelected;
                    }
                    const preventEvt = e.ctrlKey && range && sheet.selectedRange.includes(getRangeAddress(range));
                    if (!preventEvt && mode === 'Multiple' && (!isTouchEnd(e) && (!isTouchStart(e) ||
                        (isTouchStart(e) && ((activeIdx[0] === rowIdx && activeIdx[1] === colIdx) ||
                            this.isMergeActiveCell(sheet, activeIdx, rowIdx, colIdx)))) || isColSelected || isRowSelected)) {
                        document.addEventListener(getMoveEvent().split(' ')[0], this.mouseMoveEvt);
                        if (!Browser.isPointer) {
                            if (Browser.isIos && isTouchStart(e) && e.target && e.target.classList.contains('e-cell')) {
                                e.preventDefault();
                            }
                            document.addEventListener(getMoveEvent().split(' ')[1], this.mouseMoveEvt, { passive: false });
                        }
                        this.touchSelectionStarted = true;
                    }
                    else {
                        this.touchSelectionStarted = false;
                    }
                    if (!isTouchEnd(e)) {
                        if (preventEvt) {
                            if (this.parent.isEdit) {
                                const updateFormulaCurPos = (e) => {
                                    EventHandler.remove(document, getEndEvent(), updateFormulaCurPos);
                                    this.updateFormulaCursorPosition(e);
                                };
                                EventHandler.add(document, getEndEvent(), updateFormulaCurPos, this);
                            }
                        }
                        else {
                            EventHandler.add(document, getEndEvent(), this.mouseUpHandler, this);
                        }
                    }
                    const targetElement = e.target;
                    let isNoteAvailable = targetElement.className === 'e-addNoteIndicator';
                    if (!isNoteAvailable && targetElement.children.length > 0) {
                        const className = targetElement.children[targetElement.childElementCount - 1].className;
                        isNoteAvailable = typeof className === 'string' && className.indexOf('e-addNoteIndicator') > -1;
                    }
                    if (isTouchStart(e) && isNoteAvailable) {
                        const cellIndexes = getCellIndexes(getRangeAddress(range).split(':')[0]);
                        this.parent.notify(showNote, { rowIndex: cellIndexes[0], columnIndex: cellIndexes[1], isNoteEditable: false });
                        this.isNoteTouch = true;
                    }
                    let isCommentAvailable = targetElement.className === 'e-comment-indicator';
                    if (!isCommentAvailable && targetElement.children.length > 0) {
                        const className = targetElement.children[targetElement.childElementCount - 1].className;
                        isCommentAvailable = typeof className === 'string' && className.indexOf('e-comment-indicator') > -1;
                    }
                    if (isTouchStart(e)) {
                        if (isNoteAvailable) {
                            const cellIndexes = getCellIndexes(getRangeAddress(range).split(':')[0]);
                            this.parent.notify(showNote, { rowIndex: cellIndexes[0], columnIndex: cellIndexes[1], isNoteEditable: false });
                            this.isNoteTouch = true;
                        }
                        if (isCommentAvailable) {
                            const cellIndexes = getCellIndexes(getRangeAddress(range).split(':')[0]);
                            this.parent.notify(initiateComment, { rowIndex: cellIndexes[0], columnIndex: cellIndexes[1], isSelection: true });
                            this.isCommentTouch = true;
                            this.parent.spreadsheetCommentModule.isCommentVisibleOnTouch = true;
                        }
                    }
                    if (isTouchStart(e) && !(isColSelected || isRowSelected)) {
                        this.touchEvt = e;
                        return;
                    }
                    const isMobileContextMenuTrigger = isTouchEnd(e) && this.isMobileContextMenuOpening(e);
                    if (isMobileContextMenuTrigger) {
                        if (Browser.isDevice && !Browser.isAndroid) {
                            e.preventDefault();
                        }
                    }
                    else if (range) {
                        this.selectRangeByIdx(range, e);
                    }
                    if (!this.isNoteTouch && e.type.indexOf('mouse') > -1 && isNoteAvailable) {
                        const cellIndexes = getCellIndexes(getRangeAddress(range).split(':')[0]);
                        this.parent.notify(showNote, { rowIndex: cellIndexes[0], columnIndex: cellIndexes[1], isNoteEditable: false });
                    }
                    if (this.parent.isMobileView()) {
                        this.parent.element.classList.add('e-mobile-focused');
                        this.parent.renderModule.setSheetPanelSize();
                    }
                }
            }
        }
        if (isFormulaEdit && this.parent.isEdit) {
            const targetElement = e.target;
            const validSelectors = ['e-cell', 'e-wrap-content', 'e-header-cell', 'e-cf-databar', 'e-databar', 'e-databar-value', 'e-fill-before',
                'e-fill', 'e-fill-sec', 'e-hyperlink', 'e-iconsetspan'];
            if (validSelectors.some((cls) => targetElement.classList.contains(cls))) {
                let range = this.parent.getActiveSheet().selectedRange;
                const lastRange = range.split(' ');
                range = isSingleCell(getIndexesFromAddress(lastRange[lastRange.length - 1])) ? lastRange[lastRange.length - 1].split(':')[0] :
                    lastRange[lastRange.length - 1];
                this.parent.notify(addressHandle, { range: range, isSelect: false, isMouseDown: e.ctrlKey });
            }
        }
    }
    mouseMoveHandler(e) {
        const sheet = this.parent.getActiveSheet();
        if (isTouchMove(e)) {
            e.preventDefault();
        }
        const eventArgs = { action: 'getCurrentEditValue', editedValue: '' };
        this.parent.notify(editOperation, eventArgs);
        const isFormulaEdit = checkIsFormula(eventArgs.editedValue, true);
        const verticalContent = this.parent.getMainContent().parentElement;
        const horizontalContent = this.parent.element.getElementsByClassName('e-scroller')[0];
        const clientRect = verticalContent.getBoundingClientRect();
        const frozenCol = this.parent.frozenColCount(sheet);
        let left = clientRect.left + this.parent.sheetModule.getRowHeaderWidth(sheet, false, true);
        let right = clientRect.right - getScrollBarWidth();
        const top = clientRect.top;
        const bottom = clientRect.bottom;
        const clientX = getClientX(e);
        const clientY = getClientY(e);
        // remove math.min or handle top and left auto scroll
        let colIdx = this.isRowSelected ? sheet.colCount - 1 :
            this.getColIdxFromClientX({ clientX: clientX, target: e.target, mouseMove: true });
        let rowIdx = this.isColSelected ? sheet.rowCount - 1 :
            this.getRowIdxFromClientY({ clientY: clientY, target: e.target, mouseMove: true });
        let prevIndex;
        let rangeIndex;
        if (e.ctrlKey) {
            const selRanges = sheet.selectedRange.split(' ');
            prevIndex = getRangeIndexes(selRanges[selRanges.length - 1]);
        }
        else {
            prevIndex = getRangeIndexes(sheet.selectedRange);
        }
        if (Browser.isDevice) {
            const screenWidth = screen.availWidth;
            if (right >= screenWidth - 40) {
                right -= (40 - (screenWidth - right));
            }
            if (!sheet.showHeaders && left < 40) {
                left += (40 - left);
            }
        }
        const mergeArgs = { range: [rowIdx, colIdx, rowIdx, colIdx] };
        this.parent.notify(activeCellMergedRange, mergeArgs);
        if (mergeArgs.range[2] === prevIndex[2] && mergeArgs.range[3] === prevIndex[3] && clientY <= bottom && clientY >= top &&
            clientX <= right && clientX >= left) {
            return;
        }
        const frozenRow = this.parent.frozenRowCount(sheet);
        if (!isFormulaEdit && !this.isColSelected && !this.isRowSelected) {
            prevIndex = getCellIndexes(sheet.activeCell);
        }
        const isScrollDown = clientY > bottom && !this.isColSelected && rowIdx < sheet.rowCount;
        const isScrollUp = clientY < top && rowIdx >= 0 && !this.isColSelected &&
            !!verticalContent.scrollTop && (!frozenRow || prevIndex[0] >= frozenRow);
        const isScrollRight = clientX > right && !this.isRowSelected && colIdx < sheet.colCount;
        const isScrollLeft = clientX < left && colIdx >= 0 && !this.isRowSelected &&
            !!horizontalContent.scrollLeft && (!frozenCol || prevIndex[1] >= frozenCol);
        this.clearInterval();
        let scrollUpRowIdx;
        let scrollUpColIdx;
        if (isScrollDown || isScrollUp || isScrollRight || isScrollLeft) {
            if (isScrollUp || isScrollLeft) {
                scrollUpRowIdx = rowIdx;
                scrollUpColIdx = colIdx;
            }
            const scrollSelection = () => {
                if (isScrollDown || isScrollUp) {
                    rowIdx = this.getRowIdxFromClientY({ clientY: isScrollDown ? bottom : top });
                    if (rowIdx >= sheet.rowCount) { // clear interval when scroll up
                        this.clearInterval();
                        return;
                    }
                    verticalContent.scrollTop += (isScrollDown ? 1 : -1) * getRowHeight(sheet, rowIdx);
                }
                if (isScrollRight || isScrollLeft) {
                    colIdx = this.getColIdxFromClientX({ clientX: isScrollRight ? right : left, isFScroll: true });
                    if (colIdx >= sheet.colCount) { // clear interval when scroll left
                        this.clearInterval();
                        return;
                    }
                    horizontalContent.scrollLeft += (isScrollRight ? 1 : -1) * getColumnWidth(sheet, colIdx);
                }
                if ((isScrollUp && sheet.frozenRows && !verticalContent.scrollTop) ||
                    (isScrollLeft && sheet.frozenColumns && !horizontalContent.scrollLeft)) {
                    this.selectRangeByIdx([].concat(prevIndex[0], prevIndex[1], [scrollUpRowIdx, scrollUpColIdx]), e);
                    this.clearInterval();
                    return;
                }
                this.selectRangeByIdx([].concat(prevIndex[0], prevIndex[1], [rowIdx, colIdx]), e, null, false, false, false, undefined, false, false, true);
            };
            scrollSelection();
            this.scrollInterval = setInterval(() => {
                scrollSelection();
                this.clearInterval();
                this.scrollInterval = setInterval(scrollSelection, 100);
            });
        }
        else {
            let indexes = [].concat(prevIndex[0], prevIndex[1], [rowIdx, colIdx]);
            if (frozenRow && indexes[0] < frozenRow && indexes[2] >= frozenRow && verticalContent.scrollTop && !this.isColSelected) {
                verticalContent.scrollTop = 0;
                indexes[2] = frozenRow;
            }
            if (frozenCol && indexes[1] < frozenCol && indexes[3] >= frozenCol && horizontalContent.scrollLeft && !this.isRowSelected) {
                horizontalContent.scrollLeft = 0;
                indexes[3] = frozenCol;
            }
            if (this.isautoFillClicked) {
                if (e.target.classList.contains('e-autofill')) {
                    this.dAutoFillCell = sheet.selectedRange;
                }
                const args = { e: e, indexes: null };
                this.parent.notify(selectAutoFillRange, args);
                indexes = args.indexes;
                rangeIndex = indexes;
            }
            this.selectRangeByIdx(indexes, e, null, false, false, false, undefined, false, false, true);
        }
        if (isFormulaEdit && this.parent.isEdit && !closest(e.target, '#' + this.parent.element.id + '_edit')) {
            let range;
            if (this.isautoFillClicked) {
                range = getRangeAddress(rangeIndex);
            }
            else {
                range = this.parent.getActiveSheet().selectedRange;
            }
            const lastRange = range.split(' ');
            this.parent.notify(addressHandle, {
                range: getRangeAddress(getSwapRange(getRangeIndexes(lastRange[lastRange.length - 1]))), isSelect: false
            });
        }
    }
    mouseUpHandler(e) {
        const rowIdx = this.getRowIdxFromClientY({ clientY: getClientY(e), target: e.target });
        const colIdx = this.getColIdxFromClientX({ clientX: getClientX(e), target: e.target });
        this.clearInterval();
        if (isTouchEnd(e) && !(this.isColSelected || this.isRowSelected) &&
            (this.getRowIdxFromClientY({ clientY: getClientY(this.touchEvt), target: e.target }) === rowIdx &&
                this.getColIdxFromClientX({ clientX: getClientX(this.touchEvt), target: e.target }) === colIdx)) {
            this.mouseDownHandler(e);
        }
        document.removeEventListener(getMoveEvent().split(' ')[0], this.mouseMoveEvt);
        if (!Browser.isPointer) {
            document.removeEventListener(getMoveEvent().split(' ')[1], this.mouseMoveEvt);
        }
        EventHandler.remove(document, getEndEvent(), this.mouseUpHandler);
        const sheet = this.parent.getActiveSheet();
        if (sheet.frozenRows || sheet.frozenColumns) {
            removeRangeEle(this.parent.element, null, 'e-cur-selection', true, true);
        }
        this.parent.notify(mouseUpAfterSelection, e);
        if (this.isautoFillClicked) {
            const sheet = this.parent.getActiveSheet();
            const indexes = getRangeIndexes(sheet.selectedRange);
            const isRowSelect = isRowSelected(sheet, indexes);
            const isColumnSelect = isColumnSelected(sheet, indexes);
            if (!(isColumnSelect && indexes[1] === colIdx) && !(isRowSelect && indexes[0] === rowIdx)) {
                if (e.target.parentElement) {
                    const autoFillDdb = e.target.parentElement.querySelector('.e-dragfill-ddb');
                    if (!autoFillDdb || autoFillDdb.classList.contains('e-hide')) {
                        this.dAutoFillCell = sheet.selectedRange;
                    }
                }
                this.parent.notify(performAutoFill, { event: e, dAutoFillCell: this.dAutoFillCell });
            }
            this.isautoFillClicked = false;
        }
        else if (!e.ctrlKey && !isDiscontinuousRange(getSelectedRange(this.parent.getActiveSheet())) || this.parent.selectionSettings.mode === 'Single') {
            this.parent.notify(positionAutoFillElement, null);
        }
        else {
            this.parent.notify(hideAutoFillElement, null);
        }
        this.updateFormulaCursorPosition(e);
    }
    updateFormulaCursorPosition(e) {
        if (this.parent.isEdit) {
            const eventArgs = { action: 'getCurrentEditValue', editedValue: '' };
            this.parent.notify(editOperation, eventArgs);
            const isFormulaEdit = checkIsFormula(eventArgs.editedValue, true);
            if (isFormulaEdit) {
                this.parent.notify(initiateCur, { isCellEdit: e.target.classList.contains('e-spreadsheet-edit') });
            }
        }
    }
    isSelected(rowIdx, colIdx) {
        let isSelected = false;
        let indexes;
        const ranges = this.parent.getActiveSheet().selectedRange.split(' ');
        for (let i = 0; i < ranges.length; i++) {
            indexes = getSwapRange(getRangeIndexes(ranges[i]));
            if (indexes[0] <= rowIdx && rowIdx <= indexes[2] && indexes[1] <= colIdx && colIdx <= indexes[3]) {
                isSelected = true;
                break;
            }
        }
        return isSelected;
    }
    virtualContentLoadedHandler(args) {
        const sheet = this.parent.getActiveSheet();
        let indexes;
        let isColSelected;
        let isRowSelected;
        sheet.selectedRange.split(' ').forEach((rng, idx) => {
            indexes = getRangeIndexes(rng);
            isRowSelected = (indexes[1] === 0 && indexes[3] === args.prevRowColCnt.colCount - 1);
            isColSelected = (indexes[0] === 0 && indexes[2] === args.prevRowColCnt.rowCount - 1);
            if (isRowSelected || isColSelected) {
                if (isColSelected && isRowSelected) {
                    indexes = [0, 0, sheet.rowCount - 1, sheet.colCount - 1];
                }
                else if (isColSelected) {
                    indexes = [0, indexes[1], sheet.rowCount - 1, indexes[3]];
                }
                else {
                    indexes = [indexes[0], 0, indexes[2], sheet.colCount - 1];
                }
                if (sheet.frozenRows || sheet.frozenColumns) {
                    this.selectRangeByIdx(indexes, { type: 'mousedown', ctrlKey: idx !== 0 }, false, false, false, false, undefined, true);
                }
                else {
                    this.selectRangeByIdx(indexes, null, true, null, null, null, idx);
                }
            }
            else {
                indexes = getRangeIndexes(rng);
                const topIdx = this.parent.viewport.topIndex + this.parent.frozenRowCount(sheet);
                const leftIdx = this.parent.viewport.leftIndex + this.parent.frozenColCount(sheet);
                this.highlightHdr(indexes, idx === 0 ? false : true, indexes[0] >= topIdx || indexes[2] >= topIdx, indexes[1] >= leftIdx || indexes[3] >= leftIdx);
            }
        });
    }
    clearInterval() {
        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        }
    }
    getScrollLeft() {
        return this.parent.scrollModule ? this.parent.scrollModule.prevScroll.scrollLeft : 0;
    }
    cellNavigateHandler(args) {
        const sheet = this.parent.getActiveSheet();
        if (sheet.isProtected && !sheet.protectSettings.selectCells && !sheet.protectSettings.selectUnLockedCells) {
            return;
        }
        args.type = 'mousedown';
        this.selectRangeByIdx(args.range, args, false, false, false, false, undefined, args.preventAnimation);
    }
    getColIdxFromClientX(e) {
        let width = 0;
        const sheet = this.parent.getActiveSheet();
        let left = 0;
        if (e.isImage) {
            left = e.clientX;
        }
        else {
            const cliRect = document.getElementById(this.parent.element.id + '_sheet').getBoundingClientRect();
            if (this.parent.enableRtl) {
                left = (cliRect.right - this.parent.sheetModule.getRowHeaderWidth(sheet, true, true)) - e.clientX;
            }
            else {
                left = e.clientX - (cliRect.left + this.parent.sheetModule.getRowHeaderWidth(sheet, true, true));
            }
            left += this.parent.viewport.beforeFreezeWidth;
            const frozenColPosition = () => {
                const frozenCol = this.parent.element.querySelector('.e-frozen-column');
                return parseInt(frozenCol.style[this.parent.enableRtl ? 'right' : 'left'], 10) / this.parent.viewport.scaleX;
            };
            if ((!e.target || (!closest(e.target, '.e-row-header') && !closest(e.target, '.e-selectall-container')) ||
                this.isScrollableArea(e.clientX, e.target, true)) && (!this.parent.frozenColCount(sheet) ||
                left > frozenColPosition() || e.isFScroll)) {
                left += (this.getScrollLeft() / this.parent.viewport.scaleX);
            }
            if (sheet.frozenRows && left < 0 && sheet.showHeaders) {
                if (e.mouseMove) {
                    return 0;
                }
                return -1;
            }
        }
        let size;
        for (let i = 0;; i++) {
            size = width += getColumnWidth(sheet, i, null, !e.isImage) / this.parent.viewport.scaleX;
            if (left < (e.isImage ? Number(addDPRValue(size).toFixed(2)) : size) ||
                (this.parent.scrollSettings.isFinite && i === sheet.colCount - 1)) {
                if (!e.isImage) {
                    e.size = left;
                }
                e.clientX = i;
                return i;
            }
        }
    }
    isScrollableArea(offset, target, isclientX) {
        if (!target.classList.contains('e-table')) {
            return false;
        }
        if (isclientX) {
            return offset > this.parent.getMainContent().getBoundingClientRect().left;
        }
        else {
            return offset > this.parent.getMainContent().parentElement.getBoundingClientRect().top;
        }
    }
    getRowIdxFromClientY(args) {
        let height = 0;
        const sheet = this.parent.getActiveSheet();
        let top = 0;
        if (args.isImage) {
            top = args.clientY;
        }
        else {
            const sheetEle = document.getElementById(this.parent.element.id + '_sheet');
            top = args.clientY + this.parent.viewport.beforeFreezeHeight - (sheetEle.getBoundingClientRect().top +
                (sheet.showHeaders ? (args.isOverlay ? 30 : 31) / this.parent.viewport.scaleY : 0));
            if (!args.target || !closest(args.target, '.e-header-panel') || this.isScrollableArea(args.clientY, args.target)) {
                top += (this.parent.getMainContent().parentElement.scrollTop / this.parent.viewport.scaleY);
            }
            if (sheet.frozenColumns && top < 0 && sheet.showHeaders) {
                if (args.mouseMove) {
                    return 0;
                }
                return -1;
            }
        }
        let size;
        for (let i = 0;; i++) {
            size = height += getRowHeight(sheet, i, (args.isCheckDPR || !args.isImage)) / this.parent.viewport.scaleY;
            if (top < (args.isImage ? Number(addDPRValue(size).toFixed(2)) : size) ||
                (this.parent.scrollSettings.isFinite && i === sheet.rowCount - 1)) {
                if (!args.isImage) {
                    args.size = top;
                }
                args.clientY = i;
                return i;
            }
        }
    }
    initFormulaReferenceIndicator(range) {
        if (this.parent.isEdit) {
            const forRefIndicator = this.parent.createElement('div', { className: 'e-formularef-indicator' });
            forRefIndicator.appendChild(this.parent.createElement('div', { className: 'e-top' }));
            forRefIndicator.appendChild(this.parent.createElement('div', { className: 'e-bottom' }));
            forRefIndicator.appendChild(this.parent.createElement('div', { className: 'e-left' }));
            forRefIndicator.appendChild(this.parent.createElement('div', { className: 'e-right' }));
            this.parent.getMainContent().appendChild(forRefIndicator);
            setPosition(this.parent, forRefIndicator, range, 'e-formularef-indicator');
        }
    }
    isMouseEvent(e) {
        return isMouseDown(e) || isMouseUp(e) || isMouseMove(e);
    }
    selectRangeByIdx(range, e, isScrollRefresh, isActCellChanged, isInit, skipChecking, selectedRowColIdx, preventAnimation, isisRowHeightChanged, isMouseMoveScroll) {
        const isMouseEvent = e && this.isMouseEvent(e);
        if (e && e.target && isMouseEvent && closest(e.target, '#' + this.parent.element.id + '_edit')) {
            return;
        }
        const eventArgs = { action: 'getCurrentEditValue', editedValue: '',
            endFormulaRef: false };
        this.parent.notify(editOperation, eventArgs);
        const isFormulaEdit = (this.parent.isEdit ? checkIsFormula(eventArgs.editedValue, true) : false) &&
            !eventArgs.endFormulaRef;
        const isMultiRange = e && e.ctrlKey && isMouseDown(e) && this.parent.selectionSettings.mode !== 'Single';
        let ele;
        if (!isMultiRange) {
            ele = this.getSelectionElement(e, selectedRowColIdx);
        }
        const sheet = this.parent.getActiveSheet();
        const topLeftIdx = getRangeIndexes(sheet.topLeftCell);
        const formulaRefIndicator = this.parent.element.querySelector('.e-formularef-indicator');
        const mergeArgs = { range: [].slice.call(range), isActiveCell: false, skipChecking: skipChecking };
        let isMergeRange;
        let rowColSelectArgs = this.isRowColSelected(range);
        if (!rowColSelectArgs.isColSelected && !rowColSelectArgs.isRowSelected) {
            this.parent.notify(mergedRange, mergeArgs);
        }
        if (range !== mergeArgs.range) {
            isMergeRange = true;
        }
        range = mergeArgs.range;
        let promise = new Promise((resolve) => { resolve((() => { })()); });
        const args = { range: getRangeAddress(range), cancel: false };
        if (sheet.isProtected) {
            const protectCell = getCell(range[2], range[3], sheet);
            if (sheet.protectSettings.selectUnLockedCells && !sheet.protectSettings.selectCells) {
                if (!isNullOrUndefined(protectCell)) {
                    if ((protectCell.isLocked === true || isNullOrUndefined(protectCell.isLocked))) {
                        return;
                    }
                    else {
                        const sheetEle = this.parent.element.getElementsByClassName('e-sheet-panel')[0];
                        if (sheetEle && sheetEle.classList.contains('e-protected')) {
                            sheetEle.classList.remove('e-protected');
                        }
                    }
                }
                else if (!sheet.protectSettings.selectCells) {
                    return;
                }
            }
        }
        this.parent.trigger('beforeSelect', args);
        if (args.cancel) {
            return;
        }
        if (isFormulaEdit && formulaRefIndicator) {
            formulaRefIndicator.parentElement.removeChild(formulaRefIndicator);
        }
        if (!isisRowHeightChanged) {
            this.parent.notify(hideAutoFillOptions, null);
        }
        if ((isSingleCell(range) || mergeArgs.isActiveCell) && !isMultiRange) {
            if (ele) {
                if (!ele.classList.contains('e-multi-range')) {
                    ele.classList.add('e-hide');
                }
                if (sheet.frozenRows || sheet.frozenColumns) {
                    const clsName = isMouseMove(e) ? 'e-cur-selection' : 'e-selection';
                    removeRangeEle(this.parent.getSelectAllContent(), null, clsName, true);
                    removeRangeEle(this.parent.getColumnHeaderContent(), null, clsName, true);
                    removeRangeEle(this.parent.getRowHeaderContent(), null, clsName, true);
                }
            }
            if (!sheet.frozenColumns && !sheet.frozenRows && ele) {
                setPosition(this.parent, ele, range);
            }
            if (isFormulaEdit && e && e.target && (!isMouseEvent || !e.target.classList.contains('e-spreadsheet-edit'))
                && this.parent.isEdit) {
                const addRefArgs = {
                    range: getRangeAddress(range).split(':')[0], isSelect: true
                };
                this.parent.notify(addressHandle, addRefArgs);
                if (addRefArgs.isAlertDlgOpen) {
                    return;
                }
                this.initFormulaReferenceIndicator(range);
            }
        }
        else {
            if (isMultiRange) {
                if (selectedRowColIdx === undefined) {
                    let selRange = getRangeAddress(range);
                    if (sheet.selectedRange.includes(selRange) && !isFormulaEdit) {
                        const selRanges = sheet.selectedRange.split(' ');
                        if (selRanges.length > 1) {
                            selRanges.splice(selRanges.indexOf(selRange), 1);
                            selRange = selRanges.join(' ');
                        }
                        else {
                            selRange = sheet.activeCell + ':' + sheet.activeCell;
                        }
                        this.selectRange({ address: selRange });
                        return;
                    }
                    else {
                        ele = this.getSelectionElement(e, selectedRowColIdx);
                    }
                }
                else {
                    ele = this.getSelectionElement(e, selectedRowColIdx);
                }
            }
            if (isFormulaEdit && this.parent.isEdit) {
                if (e && e.target && (!isMouseEvent || !e.target.classList.contains('e-spreadsheet-edit')) && this.parent.isEdit) {
                    const addRefArgs = {
                        range: getRangeAddress(range), isSelect: true
                    };
                    this.parent.notify(addressHandle, addRefArgs);
                    if (addRefArgs.isAlertDlgOpen) {
                        return;
                    }
                    this.initFormulaReferenceIndicator(range);
                }
            }
            else {
                let clsName;
                if (ele) {
                    ele.classList.remove('e-hide');
                    if (sheet.frozenRows || sheet.frozenColumns) {
                        if (e && e.target || isMultiRange) {
                            clsName = 'e-cur-selection';
                            if (isMouseMove(e) && ele.classList.contains('e-cur-selection')) {
                                ele.classList.add('e-hide');
                            }
                            else {
                                ele.classList.add(clsName);
                            }
                        }
                        if (!isMultiRange && (this.isColSelected || this.isRowSelected) && isMouseDown(e)) {
                            removeRangeEle(this.parent.getSelectAllContent(), null, 'e-selection');
                            removeRangeEle(this.parent.getColumnHeaderContent(), null, 'e-selection');
                            removeRangeEle(this.parent.getRowHeaderContent(), null, 'e-selection');
                        }
                    }
                }
                const offset = (this.isColSelected && this.isRowSelected) ? undefined
                    : this.getOffset(range[2], range[3]);
                if (isMergeRange && offset) { // Need to handle half hidden merge cell in better way
                    offset.left = { idx: 0, size: 0 };
                }
                promise = setPosition(this.parent, ele, range, clsName, preventAnimation, isMultiRange, isMultiRange && !e.target) ||
                    promise;
            }
        }
        const eArgs = { action: 'getCurrentEditSheetIdx', sheetIndex: null };
        this.parent.notify(editOperation, eArgs);
        if (sheet.frozenColumns && range[1] > 0 && range[1] === topLeftIdx[1] && range[3] === sheet.colCount - 1) {
            range[1] = 0;
        }
        if (sheet.frozenRows && range[0] > 0 && range[0] === topLeftIdx[0] && range[2] === sheet.rowCount - 1) {
            range[0] = 0;
        }
        let selRange = getRangeAddress(range);
        if (e && e.ctrlKey && (isMouseMove(e) || isMouseUp(e)) && !isFormulaEdit) {
            selRange = sheet.selectedRange.slice(0, sheet.selectedRange.lastIndexOf(' ')) + ' ' + selRange;
        }
        else if (selectedRowColIdx > -1) {
            const selRanges = sheet.selectedRange.split(' ');
            selRanges[selectedRowColIdx] = selRange;
            selRange = selRanges.join(' ');
        }
        if (!isFormulaEdit && !this.isautoFillClicked) {
            let isSelectRangeChange = false;
            if (sheet.selectedRange !== selRange) {
                isSelectRangeChange = true;
            }
            updateSelectedRange(this.parent, selRange, sheet, isMultiRange);
            if (isSelectRangeChange) {
                promise.then(() => {
                    if (this.parent) {
                        this.parent.trigger('select', { range: this.parent.getActiveSheet().selectedRange });
                    }
                });
            }
        }
        else if (!isInit && !this.isautoFillClicked) {
            updateSelectedRange(this.parent, selRange, sheet, isMultiRange);
        }
        rowColSelectArgs = this.isRowColSelected(range, isMouseMoveScroll);
        this.isRowSelected = rowColSelectArgs.isRowSelected;
        this.isColSelected = rowColSelectArgs.isColSelected;
        this.highlightHdr(range, e && e.ctrlKey && this.parent.selectionSettings.mode !== 'Single');
        if (!isScrollRefresh && !(e && (e.type === 'mousemove' || isTouchMove(e)))) {
            if (!isFormulaEdit) {
                this.updateActiveCell(isActCellChanged ? getRangeIndexes(sheet.activeCell) : range, isInit, preventAnimation);
            }
            else if (eArgs.sheetIndex === this.parent.getActiveSheet().id - 1 && isInit) {
                isActCellChanged = true;
                this.updateActiveCell(isActCellChanged ? getRangeIndexes(sheet.activeCell) : range, isInit, preventAnimation);
            }
            else if (!this.parent.isEdit) {
                this.updateActiveCell(isActCellChanged ? getRangeIndexes(sheet.activeCell) : range, isInit, preventAnimation);
            }
        }
        if (isNullOrUndefined(e)) {
            e = { type: 'mousedown' };
        }
        if (!isFormulaEdit) {
            this.parent.notify(selectionComplete, e);
        }
        else if (!isInit) {
            this.parent.notify(selectionComplete, e);
        }
        if (!isMultiRange && !isDiscontinuousRange(getSelectedRange(this.parent.getActiveSheet()))) {
            this.parent.notify(positionAutoFillElement, { preventAnimation: preventAnimation, isSelection: isInit });
        }
        else {
            this.parent.notify(hideAutoFillElement, null);
        }
        if (this.parent.showAggregate) {
            this.parent.notify(showAggregate, {});
        }
        this.parent.notify(refreshOverlayElem, null);
    }
    isRowColSelected(indexes, isMouseMoveScroll) {
        if (isMouseMoveScroll && this.parent.scrollSettings.isFinite) {
            return { isRowSelected: this.isRowSelected,
                isColSelected: this.isColSelected };
        }
        const sheet = this.parent.getActiveSheet();
        return { isRowSelected: indexes[1] === 0 && indexes[3] === sheet.colCount - 1,
            isColSelected: indexes[0] === 0 && indexes[2] === sheet.rowCount - 1 };
    }
    updateActiveCell(range, isInit, preventAnimation) {
        const sheet = this.parent.getActiveSheet();
        const topLeftIdx = getRangeIndexes(sheet.topLeftCell);
        let rowIdx;
        let colIdx;
        let isMergeRange;
        if (this.isColSelected) {
            rowIdx = topLeftIdx[0];
            colIdx = range[1];
            if (this.isRowSelected) {
                colIdx = topLeftIdx[1];
            }
        }
        else {
            rowIdx = range[0];
            colIdx = range[1];
            if (this.isRowSelected) {
                colIdx = topLeftIdx[1];
            }
        }
        const mergeArgs = { range: [rowIdx, colIdx, ...[rowIdx, colIdx]] };
        this.parent.notify(activeCellMergedRange, mergeArgs);
        if (range !== mergeArgs.range) {
            isMergeRange = true;
        }
        range = mergeArgs.range;
        if (sheet.activeCell !== getCellAddress(range[0], range[1]) || isInit) {
            this.previousActiveCell = sheet.activeCell.indexOf(':') > -1 ? this.previousActiveCell : sheet.activeCell;
            this.parent.setSheetPropertyOnMute(sheet, 'activeCell', getCellAddress(range[0], range[1]));
            if (sheet.isProtected) {
                const element = this.parent.element.querySelector('.e-formula-bar');
                const cell = getCell(range[0], range[1], sheet);
                const isCellLocked = isLocked(cell, getColumn(sheet, range[1]));
                if (isCellLocked && element && !element.disabled) {
                    element.disabled = true;
                }
                else if (!isCellLocked && element && element.disabled) {
                    element.disabled = false;
                }
            }
            if (this.getActiveCell()) {
                const offset = this.getOffset(range[2], range[3]);
                if (isMergeRange) {
                    offset.left = { idx: 0, size: 0 };
                }
                setPosition(this.parent, this.getActiveCell(), range, 'e-active-cell', preventAnimation);
            }
            this.parent.notify(activeCellChanged, null);
        }
        else {
            setPosition(this.parent, this.getActiveCell(), range, 'e-active-cell', preventAnimation);
        }
    }
    getOffset(rowIdx, colIdx) {
        const offset = { left: { idx: 0, size: 0 }, top: { idx: 0, size: 0 } };
        if (this.parent.scrollModule) {
            if (colIdx >= this.parent.scrollModule.offset.left.idx) {
                offset.left = this.parent.scrollModule.offset.left;
            }
            if (rowIdx >= this.parent.scrollModule.offset.top.idx) {
                offset.top = this.parent.scrollModule.offset.top;
            }
        }
        return offset;
    }
    getSelectionElement(e, selectedRowColIdx) {
        const sheet = this.parent.getActiveSheet();
        if (e && e.ctrlKey && !this.parent.isEdit && this.parent.selectionSettings.mode !== 'Single') {
            if (isMouseUp(e) || isMouseMove(e)) {
                if (sheet.frozenColumns || sheet.frozenRows) {
                    let ele = this.parent.getMainContent().querySelector('.e-cur-selection');
                    if (ele) {
                        return ele;
                    }
                    else {
                        ele = this.parent.element.querySelector('.e-multi-range');
                        return ele && ele.cloneNode();
                    }
                }
                else {
                    return this.parent.getMainContent().querySelector('.e-selection:last-child');
                }
            }
            else {
                const selElem = this.parent.getMainContent().getElementsByClassName('e-selection')[0];
                const ele = selElem.cloneNode();
                ele.classList.add('e-multi-range');
                if (sheet.frozenColumns || sheet.frozenRows) {
                    if (!sheet.selectedRange.includes(' ')) {
                        selElem.classList.remove('e-hide');
                        setPosition(this.parent, selElem, getSwapRange(getRangeIndexes(sheet.selectedRange)), undefined, false, true);
                    }
                    if (!this.parent.getMainContent().querySelector('.e-multi-range') && selElem.classList.contains('e-hide')) {
                        return selElem;
                    }
                    return ele;
                }
                else {
                    selElem.classList.remove('e-hide');
                    return this.parent.getMainContent().appendChild(ele);
                }
            }
        }
        else if (selectedRowColIdx > -1) {
            return ((sheet.frozenRows || sheet.frozenColumns) ?
                this.parent.element.querySelector('.e-sheet').getElementsByClassName('e-selection')[selectedRowColIdx] :
                this.parent.getMainContent().getElementsByClassName('e-selection')[selectedRowColIdx]);
        }
        else {
            const elems = [].slice.call(this.parent.element.getElementsByClassName('e-multi-range'));
            elems.forEach((ele) => {
                remove(ele);
            });
            return this.parent.getMainContent().getElementsByClassName('e-selection')[0];
        }
    }
    getActiveCell() {
        return this.parent.getMainContent().getElementsByClassName('e-active-cell')[0];
    }
    getSheetElement() {
        return document.getElementById(this.parent.element.id + '_sheet');
    }
    highlightHdr(range, isMultiRange, isRowRefresh = true, isColRefresh = true) {
        const sheet = this.parent.getActiveSheet();
        if (sheet.showHeaders) {
            if (!isMultiRange) {
                removeClass(this.getSheetElement().querySelectorAll('.e-highlight'), 'e-highlight');
                removeClass(this.getSheetElement().querySelectorAll('.e-prev-highlight'), 'e-prev-highlight');
            }
            const selectAllEle = this.parent.element.getElementsByClassName('e-select-all-cell')[0];
            if (selectAllEle) {
                removeClass([selectAllEle], ['e-prev-highlight-right', 'e-prev-highlight-bottom']);
            }
            const rowHdr = [];
            const colHdr = [];
            const swapRange = getSwapRange(range);
            if (this.isRowSelected) {
                swapRange[1] = skipHiddenIdx(sheet, swapRange[1], true, 'columns');
            }
            if (this.isColSelected) {
                swapRange[0] = skipHiddenIdx(sheet, swapRange[0], true);
            }
            const frozenIdx = [0, 0, 0, 0];
            const indexes = [0, 0, 0, 0];
            const topLeftIndex = getCellIndexes(sheet.topLeftCell);
            let i;
            let j;
            const updateIndex = (freezePane, layout, offset) => {
                let idx;
                let hiddenCount;
                if (freezePane && swapRange[i] < freezePane) {
                    topLeftIndex[i] = skipHiddenIdx(sheet, topLeftIndex[i], true, layout);
                    const startIdx = skipHiddenIdx(sheet, swapRange[i], true, layout);
                    if (startIdx === topLeftIndex[i]) {
                        swapRange[i] = startIdx;
                    }
                    hiddenCount = this.parent.hiddenCount(topLeftIndex[i], swapRange[i] - 1, layout, sheet);
                    frozenIdx[i] = swapRange[i] - hiddenCount - topLeftIndex[i];
                    idx = swapRange[j] < freezePane ? swapRange[j] : freezePane - 1;
                    frozenIdx[j] = idx - this.parent.hiddenCount(swapRange[i], idx, layout, sheet) - hiddenCount -
                        topLeftIndex[i] + 1;
                    idx = this.parent.viewport[`${offset}`] + freezePane;
                    if (swapRange[j] >= idx) {
                        indexes[i] = 0;
                        indexes[i] -= this.parent.hiddenCount(idx, idx, layout, sheet);
                        indexes[j] = swapRange[j] - this.parent.hiddenCount(idx, swapRange[j], layout, sheet) - idx + 1;
                    }
                }
                else {
                    idx = skipHiddenIdx(sheet, this.parent.viewport[`${offset}`] + freezePane, true, layout);
                    const startIdx = skipHiddenIdx(sheet, swapRange[i], true, layout);
                    if (idx === startIdx) {
                        swapRange[i] = idx;
                    }
                    hiddenCount = this.parent.hiddenCount(idx, swapRange[i] - 1, layout, sheet);
                    indexes[i] = swapRange[i] - hiddenCount - idx;
                    indexes[j] = swapRange[j] - this.parent.hiddenCount(swapRange[i], swapRange[j], layout, sheet) - hiddenCount - idx + 1;
                }
            };
            const updateCell = (idx, parent, hdrArr) => {
                const header = [].slice.call(parent.getElementsByClassName('e-header-cell'));
                for (let k = idx[i]; k < idx[j]; k++) {
                    if (header[k]) {
                        hdrArr.push(header[k]);
                    }
                }
            };
            if (isRowRefresh) {
                i = 0;
                j = 2;
                updateIndex(this.parent.frozenRowCount(sheet), 'rows', 'topIndex');
                if (sheet.frozenRows) {
                    const selectAllBody = this.parent.getSelectAllContent().querySelector('tbody');
                    if (selectAllBody) {
                        updateCell(frozenIdx, selectAllBody, rowHdr);
                    }
                }
                updateCell(indexes, this.parent.getRowHeaderContent(), rowHdr);
            }
            if (isColRefresh) {
                i = 1;
                j = 3;
                updateIndex(this.parent.frozenColCount(sheet), 'columns', 'leftIndex');
                if (sheet.frozenColumns) {
                    const selectAllHdr = this.parent.getSelectAllContent().querySelector('thead');
                    if (selectAllHdr) {
                        updateCell(frozenIdx, selectAllHdr, colHdr);
                    }
                }
                updateCell(indexes, this.parent.getColumnHeaderContent(), colHdr);
            }
            if (sheet.isProtected && !sheet.protectSettings.selectCells) {
                removeClass([].concat(rowHdr, colHdr), 'e-highlight');
            }
            else {
                addClass([].concat(rowHdr, colHdr), 'e-highlight');
            }
            if (rowHdr.length && rowHdr[0].parentElement.previousElementSibling) {
                rowHdr[0].parentElement.previousElementSibling.classList.add('e-prev-highlight');
            }
            if (colHdr.length && colHdr[0].previousElementSibling) {
                colHdr[0].previousElementSibling.classList.add('e-prev-highlight');
            }
            if (this.isRowSelected && this.isColSelected) {
                if (sheet.isProtected && !sheet.protectSettings.selectCells) {
                    document.getElementById(`${this.parent.element.id}_select_all`).classList.remove('e-highlight');
                }
                else {
                    document.getElementById(`${this.parent.element.id}_select_all`).classList.add('e-highlight');
                }
            }
            if (selectAllEle) {
                if (skipHiddenIdx(sheet, swapRange[0], true) === skipHiddenIdx(sheet, 0, true)) {
                    selectAllEle.classList.add('e-prev-highlight-bottom');
                }
                if (skipHiddenIdx(sheet, swapRange[1], true, 'columns') === skipHiddenIdx(sheet, 0, true, 'columns')) {
                    selectAllEle.classList.add('e-prev-highlight-right');
                }
            }
        }
    }
    protectHandler() {
        const range = getRangeIndexes(this.parent.getActiveSheet().selectedRange);
        const swapRange = getSwapRange(range);
        const actRange = getCellIndexes(this.parent.getActiveSheet().activeCell);
        const inRange = swapRange[0] <= actRange[0] && swapRange[2] >= actRange[0] && swapRange[1] <= actRange[1]
            && swapRange[3] >= actRange[1];
        this.selectRangeByIdx(range, null, null, inRange);
    }
    initiateFormulaSelection(args) {
        this.processFormulaEditRange(args.range, args.formulaSheetIdx);
    }
    processFormulaEditRange(val, formulaStartSheetIdx) {
        let str;
        let formulaSheetIdx = formulaStartSheetIdx;
        let i = 0;
        const eventArgs = { formula: val };
        this.parent.notify(parseFormulaArgument, eventArgs);
        const parsedVal = eventArgs.formulaArr;
        const len = parsedVal.length;
        let ctrlKeyCount = 0;
        const formulaBorder = [['e-vborderright', 'e-vborderbottom'], ['e-pborderright', 'e-pborderbottom'],
            ['e-cborderright', 'e-cborderbottom'], ['e-gborderright', 'e-gborderbottom'], ['e-oborderright', 'e-oborderbottom'],
            ['e-bborderright', 'e-bborderbottom']];
        this.clearBorder();
        const actSheetIdx = this.parent.getActiveSheet().id - 1;
        while (i < len) {
            str = parsedVal[i];
            if (this.invalidOperators.indexOf(str) > -1) {
                break;
            }
            if (isCellReference(str.toUpperCase())) {
                str = str.replace(/\$/g, '');
                if (i > 0) {
                    if (parsedVal[i - 1].lastIndexOf('!') === parsedVal[i - 1].length - 1) {
                        const sheetName = parsedVal[i - 1].substring(1, parsedVal[i - 1].lastIndexOf('!') - 1);
                        formulaSheetIdx = sheetName ? getSheetIndex(this.parent, sheetName) : formulaSheetIdx;
                    }
                }
                if (parsedVal[i + 1] === ':') {
                    i++;
                    if (parsedVal[i + 1] && isCellReference(parsedVal[i + 1].toUpperCase())) {
                        str = str + ':' + parsedVal[i + 1];
                        i++;
                    }
                }
                if (actSheetIdx === formulaSheetIdx) {
                    this.updateFormulaEditRange(str, ctrlKeyCount, formulaBorder);
                }
                formulaSheetIdx = formulaStartSheetIdx;
                ctrlKeyCount++;
            }
            i++;
        }
    }
    updateFormulaEditRange(str, i, formulaBorder) {
        const indices = getRangeIndexes(str);
        this.formulaRange[i] = str;
        this.dStartCell = { rowIndex: indices[0], colIndex: indices[1] };
        this.dEndCell = { rowIndex: indices[2], colIndex: indices[3] };
        this.focusBorder(this.dStartCell, this.dEndCell, formulaBorder[i % 6]);
    }
    chartBorderHandler(args) {
        this.focusBorder(args.startcell, args.endcell, args.classes, true, args.isMultiRange);
    }
    focusBorder(startcell, endcell, classes, isChart, isMultiRange) {
        isChart = isNullOrUndefined(isChart) ? false : isChart;
        const sheet = this.parent.getActiveSheet();
        const range = getSwapRange([startcell.rowIndex, startcell.colIndex, endcell.rowIndex, endcell.colIndex]);
        if (sheet.frozenRows || sheet.frozenColumns) {
            const rangeReference = this.parent.createElement('div', {
                className: isChart ? 'e-range-indicator e-chart-range' : 'e-range-indicator e-formuala-range'
            });
            rangeReference.appendChild(this.parent.createElement('div', { className: 'e-top' }));
            rangeReference.appendChild(this.parent.createElement('div', { className: 'e-bottom' }));
            rangeReference.appendChild(this.parent.createElement('div', { className: 'e-left' }));
            rangeReference.appendChild(this.parent.createElement('div', { className: 'e-right' }));
            setPosition(this.parent, rangeReference, range, 'e-range-indicator', undefined, isMultiRange);
            return;
        }
        const updateRefIndicator = this.getRefIndicatorFn(isChart);
        const minr = range[0];
        const minc = range[1];
        const maxr = range[2];
        const maxc = range[3];
        if (minr) {
            const rowIdx = skipHiddenIdx(sheet, minr - 1, false);
            updateRefIndicator([rowIdx, minc, rowIdx, maxc], classes[1]); // top
        }
        const maxColIdx = skipHiddenIdx(sheet, maxc, false, 'columns');
        updateRefIndicator([minr, maxColIdx, maxr, maxColIdx], classes[0]); // right
        const maxRowIdx = skipHiddenIdx(sheet, maxr, false);
        updateRefIndicator([maxRowIdx, minc, maxRowIdx, maxc], classes[1]); // bottom
        if (minc) {
            const colIdx = skipHiddenIdx(sheet, minc - 1, false, 'columns');
            updateRefIndicator([minr, colIdx, maxr, colIdx], classes[0]); // left
        }
    }
    getRefIndicatorFn(isChart) {
        const sheet = this.parent.getActiveSheet();
        const viewport = this.parent.scrollSettings.enableVirtualization ? [this.parent.viewport.topIndex,
            this.parent.viewport.leftIndex, this.parent.viewport.bottomIndex, this.parent.viewport.rightIndex] :
            [0, 0, sheet.rowCount - 1, sheet.colCount - 1];
        return (range, cls) => {
            let temp;
            let row;
            if (range[0] > range[2]) {
                temp = range[0];
                range[0] = range[2];
                range[2] = temp;
            }
            if (range[1] > range[3]) {
                temp = range[1];
                range[1] = range[3];
                range[3] = temp;
            }
            for (let rowIdx = range[0]; rowIdx <= range[2]; rowIdx++) {
                if (rowIdx >= viewport[0] && rowIdx <= viewport[2] && !isHiddenRow(sheet, rowIdx)) {
                    row = this.parent.getRow(rowIdx, null);
                    if (row) {
                        for (let colIdx = range[1]; colIdx <= range[3]; colIdx++) {
                            if (colIdx >= viewport[1] && colIdx <= viewport[3] && !isHiddenCol(sheet, colIdx)) {
                                const cell = this.parent.getCell(rowIdx, colIdx, row);
                                if (cell) {
                                    cell.classList.add(cls);
                                    if (!isChart) {
                                        cell.classList.add('e-formularef-selection');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    }
    clearBorder() {
        const sheet = this.parent.getActiveSheet();
        if (sheet.frozenColumns || sheet.frozenRows) {
            const formualIndicator = [].slice.call(this.parent.element.getElementsByClassName('e-formuala-range'));
            formualIndicator.forEach((indicator) => { detach(indicator); });
            return;
        }
        const borderEleColl = this.parent.element.getElementsByClassName('e-formularef-selection');
        for (let idx = borderEleColl.length - 1; idx >= 0; idx--) {
            const td = borderEleColl[idx];
            const classArr = ['e-vborderright', 'e-vborderbottom', 'e-pborderright', 'e-pborderbottom',
                'e-cborderright', 'e-cborderbottom', 'e-gborderright', 'e-gborderbottom', 'e-oborderright',
                'e-oborderbottom', 'e-bborderright', 'e-bborderbottom', 'e-formularef-selection'];
            for (let idx = 0; idx < classArr.length; idx++) {
                td.classList.remove(classArr[idx]);
            }
        }
        // for (let idx: number = 0; idx < borderEleColl.length; idx++) {
        //     const td: HTMLElement = borderEleColl[idx] as HTMLElement;
        // }
    }
    /* Helper method to detect if the context menu is being triggered for mobile devices */
    isMobileContextMenuOpening(e) {
        const touchDuration = e.timeStamp - (this.touchEvt ? this.touchEvt.timeStamp : e.timeStamp);
        return touchDuration > 500;
    }
    /**
     * For internal use only - Get the module name.
     *
     * @private
     * @returns {string} - Get the module name.
     */
    getModuleName() {
        return 'selection';
    }
    destroy() {
        this.removeEventListener();
        this.deInitProps();
        this.isColSelected = null;
        this.isRowSelected = null;
        this.parent = null;
    }
}
